import React from 'react';
import AnalyticsQuality from './AnalyticsQuality/AnalyticsQuality';

const QualityOfHires = ({ isRTL = false, companyUID = '', analyticsActorId = 'system' }) => (
  <AnalyticsQuality isRTL={isRTL} companyUID={companyUID} analyticsActorId={analyticsActorId} />
);

export default QualityOfHires;
